export default {"src":"/_next/static/media/checkoutCardBg.39816001.svg","height":148,"width":219,"blurWidth":0,"blurHeight":0};